var render = function render(){var _vm=this,_c=_vm._self._c;return _c('portal',{attrs:{"to":"tooltips","z-index-class":"z-50"}},[_c('modal-component',{attrs:{"show":true,"container-classes":"max-w-sm","wrapper-classes":"bg-white px-10 py-14"},on:{"close":_vm.closeModal}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }